<template>
    <v-btn
        color="blue darken-2"
        class="white--text ma-2"
        depressed
        small
        :loading="loading"
        @click="download(file)"
    >
        Modèle
        <v-icon right>mdi-download</v-icon>
    </v-btn>
</template>

<script>
import useSharedData from "@/use/SharedData";
import axios from "axios";

export default {
    name: "ImportModel",
    props: {
        fileName: String,
    },
    setup(props) {
        const {loading} = useSharedData();

        function download() {
            loading.value = true;
            axios.get("/tools/getImportModel", {
                responseType: "arraybuffer",
                params: {fileName: props.fileName},
            }).then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", props.fileName);
                document.body.appendChild(link);
                link.click();
            }).finally(() => {
                loading.value = false;
            });
        }

        return {
            loading,
            download
        }
    }
};
</script>